import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import BodyText from 'components/Luxkit/Typography/BodyText'
import { rem } from 'polished'
import React, { useContext } from 'react'
import styled from 'styled-components'
import TextLink from 'components/Luxkit/TextLink'
import Image from 'components/Common/Image'
import Subtitle from 'components/Luxkit/Typography/Subtitle'
import LinePhoneIcon from 'components/Luxkit/Icons/line/LinePhoneIcon'
import { mediaQueryUp } from 'components/utils/breakpoint'
import LETourLogo from 'components/OfferPage/TourV2/Logo/LETourLogo'
import config from 'constants/config'
import ContactContext from 'contexts/contactContext'

const USPContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${rem(32)};
  padding-top: ${rem(40)};
  border-top: 1px solid ${props => props.theme.palette.neutral.five};
  align-items: center;
  height: fit-content;

  ${mediaQueryUp.tablet} {
    gap: ${rem(40)};
    padding-top: ${rem(24)};
    grid-template-columns: min-content;
    grid-auto-flow: column;
    grid-auto-columns: 1fr;
  }
`

const USPSection = styled.div`
  display: grid;
  gap: ${rem(20)};
  grid-template-columns: ${rem(100)} 1fr;
  align-items: center;
  min-height: ${rem(120)};
`

const SubtitleWrap = styled(Subtitle)`
  min-width: ${rem(230)};
`

interface Props {
  isPrivateRequest?: boolean;
  onRequestPrivateTour: () => void
}

function TourV2USP(props: Props) {
  const {
    isPrivateRequest,
    onRequestPrivateTour,
  } = props
  const currentContact = useContext(ContactContext)
  const contact = currentContact.defaultContact
  return <USPContainer>
    <VerticalSpacer gap={12}>
      {config.BRAND === 'luxuryescapes' && <LETourLogo height={20} />}
      <SubtitleWrap variant="subtitle3">
        Enjoy these exclusive benefits when you book with {config.brandConfig.name}
      </SubtitleWrap>
    </VerticalSpacer>
    <USPSection>
      <Image fit="center" id="kxio114neo48t74rpdzs" height={120} />
      <VerticalSpacer gap={12}>
        <VerticalSpacer gap={4}>
          <BodyText variant="medium" weight="bold" colour="neutral-two">
            Our team are available 24 hours, 7 days
          </BodyText>
          <BodyText variant="medium" colour="neutral-three">
            Interested in this offer? Call our dedicated customer service team anytime.
          </BodyText>
        </VerticalSpacer>
        <TextLink
          size="medium"
          weight="bold"
          href={`tel:${contact.number}`}
          startIcon={<LinePhoneIcon />}
        >
          Call {contact.humanReadable}
        </TextLink>
      </VerticalSpacer>
    </USPSection>
    {isPrivateRequest &&
      <USPSection>
        <Image fit="center" id="private-request-20230523" height={120} />
        <VerticalSpacer gap={12}>
          <VerticalSpacer gap={4}>
            <BodyText variant="medium" weight="bold" colour="neutral-two">
              Make this a private tour
            </BodyText>
            <BodyText variant="medium" colour="neutral-three">
              Travel exclusively with family & friends at a time that works best for you.
            </BodyText>
          </VerticalSpacer>
          <TextLink size="medium" weight="bold" onClick={onRequestPrivateTour}>Request private tour</TextLink>
        </VerticalSpacer>
      </USPSection>}
  </USPContainer>
}

export default TourV2USP
